export default (function (array) {
  return array[array.length - 1];
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/getLastElement.js
// module id = ./node_modules/redux-actions/es/utils/getLastElement.js
// module chunks = 6 9 11